import * as validation from "util/validation";
import { partial } from "ramda";

const moduleConstraints = {
  name: {
    presence: {
      message: "Module name can't be blank",
    },
  },
  displayName: {
    presence: {
      message: "Module display name can't be blank",
    },
  },
  iconUrl: {
    presence: {
      message: "A thumbnail image is required",
    },
  },
  internalCode: {
    presence: {
      message: "Identifier code is required",
    },
  },
};

export const validateField = (field, value, errors = {}) =>
  validation.validateField(moduleConstraints, field, value, errors);

export const validateModule = partial(validation.validateObject, [
  moduleConstraints,
]);
